module.exports = __webpack_public_path__ + "static/img/school-8.c0af82e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-8.png
// module id = wmRu
// module chunks = 0